import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import React from 'react';

export const DebtorsIcon = ({
	bgColor = '#E5DAFF',
	width = 24,
	height = 24,
	...props
}) => {
	return (
		<PaidOutlinedIcon
			{...props}
			sx={{
				backgroundColor: bgColor,
				width,
				height,
				borderRadius: 2,
				p: 0.5,
				color: '#fff', 
			}}
		/>
	);
};
